import {
  useGetCurrentDepartmentTree,
  useGetCurrentOrganization,
} from '@/api/trafikportalen';
import { useStudentsDisabled } from '@/contexts/ConfigContext';
import { visibleFaqAudiences, type FaqAudience } from '@/helpers/visibleFaqs';
import { useHasNonSchoolDepartmentAccess } from '@/hooks/useHasNonSchoolDepartmentAccess';
import { useHasSchoolDepartmentAccess } from '@/hooks/useHasSchoolDepartmentAccess';
import { useAuth } from '@/stores/auth';

/**
 * Audiences whose FAQ the current user should see. `undefined` while an
 * organisation user's department access is still loading.
 */
export const useVisibleFaqAudiences = (): FaqAudience[] | undefined => {
  const { userProfile } = useAuth();
  const isSysadmin = !userProfile?.organization_id;
  const studentsDisabled = useStudentsDisabled();
  const hasSchoolAccess = useHasSchoolDepartmentAccess();
  const hasCompanyAccess = useHasNonSchoolDepartmentAccess();

  const organization = useGetCurrentOrganization({
    query: { enabled: !isSysadmin },
  });
  const departmentTree = useGetCurrentDepartmentTree({
    query: { enabled: !isSysadmin },
  });

  if (isSysadmin) {
    return visibleFaqAudiences({
      isSysadmin: true,
      studentsDisabled,
      hasCompanyAccess: false,
      hasSchoolAccess: false,
    });
  }

  if (!organization.isFetched || !departmentTree.isFetched) {
    return undefined;
  }

  return visibleFaqAudiences({
    isSysadmin: false,
    studentsDisabled,
    hasCompanyAccess: hasCompanyAccess === true,
    hasSchoolAccess,
  });
};
